/**
 * The Overview map's heading: its live dot and, while the feed is clamped,
 * what the map is showing instead of live data (twin slice 1, plan W3
 * step 11). The words are `feedHeadingWords`', read through `useFeedHeading`.
 *
 * The dot pulses ONLY while FeedHealth says the feed is live. Clamped, it
 * holds still in the muted colour and the heading says why, so the one
 * element on the page whose job is to say "this is live" stops saying it
 * at the same moment the canvas greys out.
 */
import { useFeedHeading } from './useFeedHeading';

export function LiveMapHeading({ siteId, label }: { siteId: string; label: string }) {
  // The building views' scrim reads the same hook (`useFeedHeading`).
  const { clamped, words } = useFeedHeading(siteId);
  const live = !clamped;
  return (
    <h2 className="nx-overview__sub" data-testid="overview-map-heading">
      <span
        className={live ? 'nx-overview__live-dot' : 'nx-overview__live-dot nx-overview__live-dot--held'}
        aria-hidden="true"
        data-testid="overview-live-dot"
        data-live={live ? 'true' : 'false'}
      />
      Live Map — {label}
      {/* Always mounted, empty while live: a live region that appears
          with its text already in it is not reliably announced. */}
      <span className="nx-overview__feed-status" role="status" data-testid="overview-feed-status">
        {words ?? ''}
      </span>
    </h2>
  );
}
